<template>
  <div id="home">
    <my-header ></my-header>
    <div class="pd20">
      <h3 class="text-center">{{'Request Quotes'|translate}}</h3>
          <div class="row">
            <div class="col mt20">
              <router-link
                class="btn btn-info"
                :to="{ name: 'AddQuote'}"
              >{{'Add quote'|translate}}</router-link>
            </div>

          </div>

          <loading v-if="working" :text="'Please wait'|translate"></loading>
          <div class="row mt20" v-if="!working">
            <div class="col-md-12 col-xs-12" v-if="search_result.length== 0">
              <div class="alert alert-info" role="alert">{{'No result'|translate}}</div>
            </div>

            <table class="table mt10" v-else>
              <thead>
                <tr>
                  <th>{{'Note'|translate}}</th>
                  <th>{{'Shipping Address'|translate}}</th>
                  <th>{{'Status'|translate}}</th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="(item) in search_result" :key="item.id">
                  <td>
                                  <router-link

                      :to="{ name: 'ViewQuote', params: { id: item.id}}"
                    >{{item.note}}</router-link>
                  </td>
                  <td>{{ item.shipping_address }}</td>
                  <td>{{ item.status_name }}</td>

                </tr>
              </tbody>
            </table>
            <paginate
              v-if="total_page > 1"
              :page-count="total_page"
              :click-handler="clickPage"
              :prev-text="'Prev'|translate"
              :next-text="'Next'|translate"
              v-model="page"
              :container-class="'pagination'"
            ></paginate>

          </div>

    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Paginate from 'vuejs-paginate'

import Loading from '@/components/elements/Loading'
export default {
  name: 'Home',
  components: {
    MyHeader,
    Loading,
    Paginate
  },
  data () {
    return {
      waiting_location: true,
      working: true,
      search_result: [],
      paginate: {
        page: 1
        // path: ""
      },
      page: 1,
      search_params: {
        address: '',
        lat: null,
        lng: null,
        dist: 0
      }
    }
  },

  methods: {

    searchStores () {
      this.working = true
      let data = {
        page: this.paginate.page
      }

      Utils.requestV2(this, true)
        .get(`/quotes/`, { params: data })
        .then(response => {
          this.working = false
          this.search_result = response.data.data
          console.log('response.data.per_page', response.data.per_page)
          // this.paginate.page = response.data.path;
          this.total_page = Utils.getTotalPages(response.data.total, response.data.per_page)
          console.log('this.search_result', this.search_result)
        })
        .catch(error => {})
    },
    clickPage (pageNum) {
      console.log('pageNum', pageNum)
      this.paginate.page = pageNum
      this.searchStores()
    }
  },

  mounted () {
    this.searchStores()
  },
  beforeDestroy () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/Quotes.vue